import history from 'history/browser'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import store from '../../engine/store'
import { Bloc, BlocRenegoAffichage } from '../ImportAll'

class ListingCreditRenego extends Component {
    render() {
        const ajouterCredit = () => {
            let r = Math.random().toString(36).substring(7)
            store.dispatch({
                type: 'SET',
                value: { key: 'tech_credit_renego_target_new', value: true },
            })
            store.dispatch({
                type: 'SET',
                value: { key: 'tech_credit_renego_target', value: r },
            })
            history.push('/tunnelmobile/', { targetView: 26 })
        }

        var listeCreditsRenego = this.props.listeCreditsRenego
            ? this.props.listeCreditsRenego
            : []
        const content = listeCreditsRenego.map((credit) => (
            <BlocRenegoAffichage key={credit} id={credit} />
        ))
        return (
            <div>
                {content}
                <Bloc
                    selectable
                    nbcolumn={1}
                    simpleWord
                    text1="Ajouter un prêt à renégocier"
                    customMethod={ajouterCredit}
                />
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        listeCreditsRenego: state.answer['credit_renego_list'],
    }
}

export default connect(mapStateToProps)(ListingCreditRenego)
